module.exports = __webpack_public_path__ + "static/media/050-mauritania.61249ac3.svg";